import React from "react";
import { Typography } from "@mui/material";
import alertLogo from "../img/icons/alert.png";
import { useTranslation } from "react-i18next";
import "./Error.css";

const Error = ({ statusCode, detail }) => {
  const { t } = useTranslation();

  return (
    <div className="error-container">
      <div className="cyt-error">
        <div className="error-header">
          <img src={alertLogo} alt="Error" />
          <span>{t("Er is een fout opgetreden")}</span>
        </div>
        <span>
          {detail
            ? detail
            : "Het lijkt erop dat er iets mis is gegaan. Probeer het later opnieuw."}
        </span>
      </div>
    </div>
  );
};

export default Error;
